import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import { useAuthContext } from "./hooks/useAuthContext";
import "./App.css";
import { Container, CssBaseline, ThemeProvider } from "@mui/material";
import Delivery from "./pages/Delivery";
import theme from "./components/ui/theme";
import NavBar from "./components/NavBar";
import Sales from "./pages/Sales";
import Review from "./pages/Review";

function App() {
  const { token, loading } = useAuthContext();

  if (loading) return;

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          {token && <NavBar />}

          <Container maxWidth="xl" sx={{ mt: 3 }}>
            <Routes>
              <Route
                exact
                path="/"
                element={token ? <Dashboard /> : <Navigate to="/login" />}
              />
              <Route
                path="/delivery"
                element={token ? <Delivery /> : <Navigate to="/login" />}
              />
              <Route
                path="/sales"
                element={token ? <Sales /> : <Navigate to="/login" />}
              />
              <Route
                path="/review"
                element={token ? <Review /> : <Navigate to="/login" />}
              />
              <Route
                path="/login"
                element={!token ? <Login /> : <Navigate to="/" />}
              />
            </Routes>
          </Container>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
